// extracted by css-extract-rspack-plugin
export default {"root":"Details_root__Jz+ZC"};